// frontend/modules/drafts/routes.tsx
import React from 'react';
import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import DraftsManagementView from './views/DraftsManagementView';
import DraftResumeView from './views/DraftResumeView';

export const draftsRoutes: RouteObject[] = [
  {
    path: '/drafts',
    element: <DraftsManagementView />,
    errorElement: <ErrorBoundary />
  },
  {
    path: '/drafts/:id/resume',
    element: <DraftResumeView />,
    errorElement: <ErrorBoundary />
  }
];
